import Cookie from 'js-cookie';

import { config } from '../config';


/**  return website cookie or false if missing or invalid
 *
 * @returns { Object, boolean } retailExperience.user cookie wrapped in object
 *   (due to prev.. using multiple cookies)
 */
export function getUserCookies() {
  const retailExperienceUserEncoded = Cookie.get('retailExperience.user');
  if(!retailExperienceUserEncoded) return false;
  const retailExperienceUserDecoded = decodeURIComponent(retailExperienceUserEncoded);
  const retailExperienceUser = JSON.parse(retailExperienceUserDecoded);

  if (!retailExperienceUser) {
    return false;
  }
  return { retailExperienceUser };
}

/**  deletes retail cookie retailExperience.user and checkout cookie sofologyUser
 *
 * @returns { undefined }
 */
export function deleteUserCookies() {
  Cookie.remove('sofologyUser', { domain: config.APP_INFO.COOKIE_DOMAIN });
  Cookie.remove('sofologyUser');
  Cookie.remove('retailExperience.user', { domain: config.APP_INFO.COOKIE_DOMAIN });
  Cookie.remove('retailExperience.user');
  // and the rest :/
  Cookie.remove('sofologySessionId', { domain: config.APP_INFO.COOKIE_DOMAIN });
  Cookie.remove('sofologySessionId');
  Cookie.remove('rex-favourites', { domain: config.APP_INFO.COOKIE_DOMAIN });
  Cookie.remove('rex-favourites');
  Cookie.remove('rex-recently-viewed', { domain: `www.${config.APP_INFO.COOKIE_DOMAIN}` });
  Cookie.remove('rex-recently-viewed');
  Cookie.remove('SofaworksMyAccount', { domain: config.APP_INFO.COOKIE_DOMAIN });
  Cookie.remove('SofaworksMyAccount');
}


/**  get and parse mySofologySofologist cookie
 *
 * @returns { Object, boolean } parsed cookie or false if cookie undefined or invalid
 * TODO: refactor checks to safeparse service function
 */
export function getSofologistCookie() {
  const rawEncoded = Cookie.get('mySofologySofologist', { domain: config.APP_INFO.COOKIE_DOMAIN });
  if(!rawEncoded) return false;
  const decoded = decodeURIComponent(rawEncoded);
  if(!decoded) return false;
  return JSON.parse(decoded);
}

/**  store sofologist information in mySofologySofologist cookie
 *
 * @param { string } token sofologist JWT
 *
 * @returns { undefined }
 */
export function setSofologistCookie(token, location, isTelStore) {
  const cookieExpiry = new Date(new Date().getTime() + (16 * 60 * 60 * 1000)); // 16 hours
  Cookie.set('mySofologySofologist', { token, location, isTelStore }, { expires: cookieExpiry, domain: config.APP_INFO.COOKIE_DOMAIN });
}


/**  delete mySofologySofologist cookie
 *
 * @returns { undefined }
 */
export function deleteSofologistCookies() {
  Cookie.remove('mySofologySofologist', { domain: config.APP_INFO.COOKIE_DOMAIN });
}



// WEBPACK FOOTER //
// ./src/services/cookieService.js